const Dropdowns = {
  init: function () {
    this.dropDownSimple();
  },

  dropDownSimple: function(){
    const dropDowns = document.querySelectorAll('[data-drop-down-simple-js]');
    if (!dropDowns || dropDowns.length === 0) return;

    dropDowns.forEach((dropDown) => {
      let trigger = dropDown.querySelector('button');

      if (trigger) {
        trigger.addEventListener('click', () => {
          if (!dropDown.classList.contains('is-active')) {
            dropDown.classList.add('is-active');
            document.addEventListener('click', outsideClickHandler);
          } else {
            dropDown.classList.remove('is-active');
            document.removeEventListener('click', outsideClickHandler);
          }
        })
      }
      function outsideClickHandler(event) {
        if (!dropDown.contains(event.target)) {
          dropDown.classList.remove('is-active');
          document.removeEventListener('click', outsideClickHandler);
        }
      }
    });
  },
};

export default Dropdowns;
